import Select, { MenuPlacement, MenuPosition } from 'react-select'
import { multiselectCustomStyles, MultiselectSelectContainer } from './CSelect.style'
import React, { FC, useEffect, useState } from 'react'
import { Option } from 'helpers/selects'

type MultiselectProps = {
  value: string
  disabled?: boolean
  placeholder?: string
  options: Option[]
  menuPlacement?: MenuPlacement
  menuPosition?: MenuPosition
  onChange: (values: string) => void
}

export const CSelect: FC<MultiselectProps> = ({
  value: initValue,
  placeholder,
  menuPlacement = 'auto',
  menuPosition = 'fixed',
  options,
  disabled,
  onChange,
}) => {
  const [value, setValue] = useState<Option | null>(options.find(option => option.value === initValue) || null)

  useEffect(() => {
    setValue(options.find(option => option.value === initValue) || null)
  }, [initValue])

  const handleChange = newValue => {
    setValue(newValue)
    onChange(newValue.value)
  }

  return (
    <MultiselectSelectContainer>
      <Select
        placeholder={placeholder}
        menuPosition={menuPosition}
        menuPlacement={menuPlacement}
        isDisabled={disabled}
        styles={multiselectCustomStyles}
        options={options}
        value={value}
        onChange={handleChange}
      />
    </MultiselectSelectContainer>
  )
}
